import React from "react";
import './text.css';
const Konec = () => {
    return (
        <div align={'start'} className="text1">
            <h2>Заключение</h2>
            
            <p></p>
            

            
            <p>Первый выпуск «Христианского вестника» вышел в 1994 году. И более двадцати пяти лет, рассказывая о том, как противостоят войне против Церкви самые разные люди, мы не могли не видеть, что многие из них изнемогают и падают перед давлением выдающей себя за нечто «традиционно-церковное» тьмы. И ведь в каком-то смысле  нынешние фундаменталисты  действительно традиционны: они наследники и тех «лжебратьев», «подсматривающих за нашей свободой», о которых говорит еще апостол Павел, и тех «церковных старост» (а иногда и «клириков», и «иерархов»), которых внедряли в церковь в долгие десятилетия советской власти органы политической полиции.</p>
            

            
            <p>Но несмотря на тяжелое, а порой трагическое содержание   «Христианского вестника» мы не уставали в заключении к этим сборникам говорить о надежде.</p>
            

            
            <p>Сейчас эти слова, может быть, еще более необходимы, чем прежде, ведь в эпоху постепенной реабилитации преступлений советского прошлого мы можем уже явно, а не только местами и временами вернуться к тому и явному, и скрытому образу богоборчества, которые связаны с минувшим столетием.</p>
            

            
            <p>Поэтому закончить
                наш сборник хотелось бы словами человека, жившего в ту эпоху, исповедника, не
                потерявшего живой веры в Церковь и оставившего нам свидетельство об этой вере –
                Сергея Иосифовича Фуделя:</p>
            

            
            <p>«Христос – в Его Тайной Вечере, Голгофе и Воскресении, Христос – в Его святости продолжает Духом Святым жить в теле Церкви. Мы можем говорить только о такой, о действительно святой Церкви, так как только такая&nbsp;Церковь&nbsp;есть любовь и надежда человечества. Она есть свет, который  "во тьме светит, и тьма не объяла его" (Ин 1:5). И она истинно существует: следы ног святых мы видим и в наши дни. Было достаточно тьмы истории.&nbsp;Церковь&nbsp;пытались смести с лица земли языческие императоры.&nbsp;Церковь&nbsp;хотели бы исказить все еретики – от гностиков до Толстого. Но гораздо страшнее для Церкви всегда была тьма внутренняя: не турецкие султаны, рубившие головы, и не люди, явно или примитивно искажавшие догматы веры и тем самым отделявшиеся от Церкви, а та сила зла, которая, никуда от Церкви внешне не отделяясь, Церковь как бы не отрицая, изнутри растлевала церковное тело, отвоевывая себе пажити порока внутри церковной ограды. Эта внутренняя тьма есть следствие отрыва веры от любви, вероучения от жизни, создание какой-то призрачной, словесной или  "символической"  веры, не идущей путем подвига любви, путем исполнения заповедей…</p>
            

            
            <p>Святая&nbsp;Церковь&nbsp; "ничего не заимствует"  от тьмы церковной, но эта тьма все время стремится  "объять"  ее, совершенно так же, как и жизнь малой церкви – отдельной человеческой души. Это есть попытка зла внутренним омертвением тканей церковного тела доказать призрачность его бытия, то есть практически, не на соборах, а на деле доказать ложность догмата о Церкви... </p>
            

            
            <p>Второй, темный
                аспект Церкви все больше расширяет свою мертвую область внутри общей церковной
                ограды. Таков предуказанный Евангелием ход церковной истории, и никакие римские
                мечтания о какой-то благополучной культурно-исторической миссии христианства, о
                его победе в истории, этот ход не изменят. Мечта об этой победе Христа в
                истории есть исконное непонимание Его дела в мире, и не только со стороны
                ветхозаветного иудейства, распявшего Христа именно за разрушение этой мечты в
                ее иудейско-националистическом аспекте, но и со стороны многих христиан.</p>
            

            
            <p>Христос в истории спасает человека, а не историю, не мир, но&nbsp;Церковь, то есть только людей, "возлюбивших явление Его". И для этих людей дано и другое пророчество Евангелия: "Созижду&nbsp;Церковь&nbsp;Мою, и врата ада не одолеют ее" (Мф 16:18). Ни темнота истории, ни все увеличивающаяся темнота церковной действительности не погасят света святой Церкви… </p>
            

            
            <p>Сколько бы истинных христиан ни осталось к концу времен, святая вселенская&nbsp;Церковь&nbsp;и тогда будет озаряться светом Пятидесятницы. И, может быть, самый победоносный, самый яркий свет Церкви будет именно тогда, когда, по Евангелию, будет так трудно "найти веру на земле"». </p>
            

            
            <p>Пусть же эти слова укрепят всех, кого пытается подавить и поглотить та тьма, которая «не есть грех церкви, но есть грех против церкви», в ком бы она ни воплощалась, и вера в Церковь поддержит всех, кто действительно ищет и находит Путь, Истину и Жизнь.  </p>
        </div>
    );
};

export default Konec;
